import React from 'react';
import { Shield } from 'lucide-react';
export function Guarantee() {
  return <section className="py-20 px-4 bg-white" data-id="element-135">
      <div className="max-w-3xl mx-auto text-center" data-id="element-136">
        <div className="bg-gradient-to-b from-amber-50 to-white border border-orange-200 rounded-3xl p-8 md:p-12 shadow-2xl relative overflow-hidden" data-id="element-137">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-32 h-32 bg-teal-200/40 blur-3xl rounded-full" data-id="element-138"></div>

          <Shield className="w-16 h-16 text-teal-600 mx-auto mb-6" data-id="element-139" />

          <h2 className="text-3xl md:text-4xl font-extrabold text-slate-900 mb-8" data-id="element-140">
            🛡️ GARANTÍA TOTAL 7 DÍAS
          </h2>

          <p className="text-xl text-slate-700 mb-8 font-medium" data-id="element-141">
            Usá el sistema durante una semana completa.
          </p>

          <div className="text-left bg-white p-6 rounded-xl border border-orange-200 mb-8 space-y-4 shadow-sm" data-id="element-142">
            <p className="text-slate-700 font-medium" data-id="element-143">Si no sentís:</p>
            <ul className="space-y-3 text-slate-700" data-id="element-144">
              <li className="flex items-start gap-3" data-id="element-145">
                <span className="text-teal-600 mt-1" data-id="element-146">•</span>
                Más claridad sobre cómo ayudar a tu ser querido en el día a día
              </li>
              <li className="flex items-start gap-3" data-id="element-147">
                <span className="text-teal-600 mt-1" data-id="element-148">•</span>
                Una diferencia real en la energía y el estado de ánimo del
                adulto mayor
              </li>
              <li className="flex items-start gap-3" data-id="element-149">
                <span className="text-teal-600 mt-1" data-id="element-150">•</span>
                Un sistema concreto para aprovechar cada momento familiar de
                forma significativa
              </li>
            </ul>
          </div>

          <p className="text-xl font-bold text-slate-900 mb-4" data-id="element-151">
            Te devolvemos el 100% del dinero.
          </p>
          <p className="text-slate-600" data-id="element-152">
            Sin preguntas. Sin formularios. Sin vueltas.
          </p>
        </div>
      </div>
    </section>;
}